"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* Created on Thu Oct 18 2018
*/

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var OutlierPriceDetectionSettings_1 = require("./OutlierPriceDetectionSettings");

var PromoPriceDetectionSettings_1 = require("./PromoPriceDetectionSettings");
/**
 * All atributes, which are required for data-cleaning algorythms.
 * @author RV
 */


var CleaningSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(CleaningSettings, _DomainObject_1$Domai);

  /**
   * Constructs globalSettings instance.
   *
   * @param referencePriceChangeIndex Indicates too much positive(+) or negative(-) x % price change.
   * If index is too high = last reference price < new reference price or too low = last reference price > new reference price,
   * then the index is highlighted (red color).
   * @param competitorReferencePriceChangeIndex Indicates too much positive(+) or negative(-) x % price change.
   * If index is too high = Last competitor reference price < new competitor reference price or
   * too low = Last competitor reference price > new competitor reference price, then the index is highlighted (red color).
   * @param internalVsCompetitorReferencePriceChangeIndex Indicates too much positive(+) or negative(-) x % price change.
   * If index is too high = Company last regular price < new competitor reference price or
   * too low = Company last regular price > new competitor reference price, then the index is highlighted (red color).
   * @param extremePriceChangeIndex Indicates too much positive(+) or negative(-) x % price change.
   * If index is too low = Company last regular price > New optimal price without constraints.
   * Or too high = Company last regular price < New optimal price without constraints, then the index is highlighted (red color).
   * @param agencyResearchWeight Set weight for scoring method for calculation of competitor reference price.
   * Competitors prices collected by agency have lower priority (x times) than data from webscraping.
   * @param webscrapingWeight Set weight for scoring method for calculation of competitor reference price.
   * Competitors prices collected by webscraping have higher priority (x times) than data from agency.
   * @param promoPriceDetectionSettings
   * @param outlierPriceDetectionSettings
   */
  function CleaningSettings(referencePriceChangeIndex, competitorReferencePriceChangeIndex, internalVsCompetitorReferencePriceChangeIndex, extremePriceChangeIndex, agencyResearchWeight, webscrapingWeight, promoPriceDetectionSettings, outlierPriceDetectionSettings) {
    var _this;

    _classCallCheck(this, CleaningSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CleaningSettings).call(this));
    _this.referencePriceChangeIndex = referencePriceChangeIndex;
    _this.competitorReferencePriceChangeIndex = competitorReferencePriceChangeIndex;
    _this.internalVsCompetitorReferencePriceChangeIndex = internalVsCompetitorReferencePriceChangeIndex;
    _this.extremePriceChangeIndex = extremePriceChangeIndex;
    _this.agencyResearchWeight = agencyResearchWeight;
    _this.webscrapingWeight = webscrapingWeight;
    _this.promoPriceDetectionSettings = promoPriceDetectionSettings;
    _this.outlierPriceDetectionSettings = outlierPriceDetectionSettings;
    return _this;
  }

  return CleaningSettings;
}(DomainObject_1.DomainObject);

exports.CleaningSettings = CleaningSettings;

CleaningSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CleaningSettings.name);
  return {
    outlierPriceDetectionSettings: builder.obj('outlierPriceDetectionSettings', OutlierPriceDetectionSettings_1.OutlierPriceDetectionSettings.schema, function (mat) {
      return new OutlierPriceDetectionSettings_1.OutlierPriceDetectionSettings(mat.outlierHistoryLength, mat.outlierLimit);
    }),
    promoPriceDetectionSettings: builder.obj('promoPriceDetectionSettings', PromoPriceDetectionSettings_1.PromoPriceDetectionSettings.schema, function (mat) {
      return new PromoPriceDetectionSettings_1.PromoPriceDetectionSettings(mat.minPriceDecrease, mat.minPriceIncrease, mat.minPriceLength, mat.maxPriceLength, mat.promoLimit);
    }),
    referencePriceChangeIndex: builder.num('referencePriceChangeIndex'),
    competitorReferencePriceChangeIndex: builder.num('competitorReferencePriceChangeIndex'),
    internalVsCompetitorReferencePriceChangeIndex: builder.num('internalVsCompetitorReferencePriceChangeIndex'),
    extremePriceChangeIndex: builder.num('extremePriceChangeIndex'),
    agencyResearchWeight: builder.num('agencyResearchWeight'),
    webscrapingWeight: builder.num('webscrapingWeight')
  };
}();